import { DatePipe } from "@angular/common";
import { AfterViewInit, EventEmitter, HostListener, OnInit } from "@angular/core";
import { FormGroup, NgForm } from "@angular/forms";
import { environment } from "environments/environment";
import { StepItem } from "../components/steps-bar/model/StepItem";
import { ActionCode } from "../enums/action-code.enum";
import { DocumentConfigurationEnum } from "../enums/document-configuration.enum";
import { InitPageType } from "../enums/init-page-type.enum";
import { LookupType } from "../enums/lookup-Type.enum";
import { ResponseMessageCode } from "../enums/response-message-code";
import { StatusCode } from "../enums/status-code.enum";
import { SuccessActionCode } from "../enums/success-action-code";
import { SuccessConfirmationCode } from "../enums/success-confirmation-code.enum";
import { DocumentEntity } from "../models/document-entity";
import { LookupEntity } from "../models/lookup-entity";
import { LookupKeyValue } from "../models/lookup-key-value";
import { ResultDetails } from "../models/result-details";
import { StepsBarConfiguration } from "../models/steps-bar-configuration";
import { TModel } from "../models/t-model";
import { PopupService } from "../modules/popup/popup.service";
import { CommonService } from "../services/common-service/common.service";
import { DocumentService } from "../services/Document-service/document-service";
import { LookupService } from "../services/lookup-service/lookup.service";
import { ResourceService } from "../services/resources-service/resource.service";
import { DocumentModel } from "../Uploader/Models/DocumentModel";
import { IApplicationService } from "./interfaces/IApplication-Service";

export abstract class EServicesBase<TApplication extends TModel> implements OnInit, AfterViewInit  {

  Application: TApplication;
  resources: any;
  isFormReady: boolean;
  isSaveApplication: boolean;
  isSubmitApplication: boolean;
  activeTab: number;
  genericErrorMessage: string;
  genericErrorBackToWorkSpace: string;
  genericErrorTitle: string;
  protected abstract tabs(): CustomTab[];
  showErrorPopup: boolean = false;
  lookupType = LookupType;
  ActionCode = ActionCode;
  StatusCode = StatusCode;
  isBack: boolean = false;
  hasError: boolean = false;
  isMobile: boolean = false;
  isResponsive: boolean = false;
  mobileOS: string = null;
  steps: StepItem[];
  activeStep: string;
  public isResourcesLoaded: boolean;
  protected documentConfiguration = DocumentConfigurationEnum;
  protected isLookupsLoaded: boolean;
  protected isApplicationLoaded: boolean;
  protected applicationId: any = null;
  protected taskId: any = null;
  protected isFormReadyEventEmitter: EventEmitter<any>;
  protected isDocumentConfigurationLoaded: boolean;
  public isExtendedLoaded: boolean = true;;
  protected isDraft: boolean = false;
  constructor(
    protected applicationService: IApplicationService,
    protected resourceService: ResourceService,
    protected lookupService: LookupService,
    protected commonService: CommonService,
    protected modalService: PopupService,
    protected documentService: DocumentService) {
    this.isResourcesLoaded = false;
    this.isLookupsLoaded = false;
    this.isApplicationLoaded = false
    this.isFormReady = false;
    this.isFormReadyEventEmitter = new EventEmitter<any>();
    this.isSaveApplication = false;
    this.isSubmitApplication = false;
    this.activeTab = 0;
    this.genericErrorTitle = "Operation Failed";
    this.genericErrorMessage = "Sorry, something went wrong please try again later.";
    this.genericErrorBackToWorkSpace = "Back to workspace";
    this.isDocumentConfigurationLoaded = false;
  }

  ngOnInit(): void {
    this.resetForm();
    var urlParams = this.commonService.getUrlParams();
    this.applicationId = urlParams["applicationid"];
    this.taskId = urlParams["taskid"];
    this.isMobile = urlParams["ismobile"] == "true" ? true : false;
    this.mobileOS = urlParams["mobileos"] != null && urlParams["mobileos"] != "undefined" ? urlParams["mobileos"] : null;
    if (this.isMobile == true) {
      this.isResponsive = false;
    }
    else  {

      this.isResponsive = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
      if (this.isResponsive) {
        this.isMobile = true
      }
    }
    this.beforeInitForm();
    //this.initForm();
    this.loadResources();
  }

  beforeInitForm(): void {

  }

  ngAfterViewInit(): void {
    this.AfterViewInit()
  }

  protected abstract TApplicationNewInstance(): TApplication;
  protected abstract getServiceFolder(): string;
  protected abstract getResourcesFileName(): string;

  protected getInitPageType(): InitPageType {
    return InitPageType.loadApplication;
  }

  protected resetForm(): void { }

  protected initForm(): void {
    this.loadLookups();
    this.loadDocumentConfiguration();
    this.extendInitForm();
    if (this.applicationId) {
      this.loadApplication(this.applicationId, this.taskId);
    }
    else {
      if (this.getInitPageType() == InitPageType.initForm) {
        this.Application = this.TApplicationNewInstance();
        this.isApplicationLoaded = true;
        this.setFormIsReady();
      }
      else {
        this.loadApplication();
      }
    }

  }

  protected extendInitForm(): void { }

  protected AfterViewInit(): void { }

  protected loadResources(): void {
    this.resourceService.getResources(this.getServiceFolder(), this.getResourcesFileName()).subscribe(result => {
      this.resources = result;
      this.genericErrorTitle = this.resources["g_popup_genericErrorTitle"];
      this.genericErrorMessage = this.resources["g_popup_genericErrorMessage"];
      this.genericErrorBackToWorkSpace = this.resources["g_popup_genericErrorBackToWorkSpace"];
      this.isResourcesLoaded = true;
      this.afterResourcesLoaded();
      //this.setFormIsReady();
      this.initForm();
    });
  }
  protected afterResourcesLoaded(): void {

  }
  protected getLookupTypes(): LookupEntity[] {
    let lookups: LookupEntity[] = [];
    return lookups;
  }

  protected loadLookups(): void {
    this.lookupService.lookupEntities[0]
    let lookups = this.getLookupTypes();
    if (lookups) {
      this.lookupService.loadLookups(lookups).subscribe(result => {
        this.isLookupsLoaded = result;
        this.handleDeletedLookups()
        this.setFormIsReady();
      }, error => {
        this.showGenericErrorPopup();
      });
    }
  }
  protected handleDeletedLookups(): void {
    if (this.Application && this.Application.CurrentRequestStatus == null) {
      if (this.lookupService.lookupEntities[this.lookupType.CRMMission] && this.lookupService.lookupEntities[this.lookupType.CRMMission].length > 0) {
        let deletedCRMMissions = environment.DeletedCRMMissions.split(',');
        this.lookupService.lookupEntities[this.lookupType.CRMMission] = this.lookupService.lookupEntities[this.lookupType.CRMMission].filter(x => deletedCRMMissions.includes(x.Key) == false);
      }

      if (this.lookupService.lookupEntities[this.lookupType.Mission] && this.lookupService.lookupEntities[this.lookupType.Mission].length > 0) {
        let deletedMissions = environment.DeletedMissions.split(',');
        this.lookupService.lookupEntities[this.lookupType.Mission] = this.lookupService.lookupEntities[this.lookupType.Mission].filter(x => deletedMissions.includes(x.Key) == false);
      }
    }
  }
  protected loadDocumentConfiguration(): void {
    let documentConfigurations = this.getDocumentConfigurations();
    if (documentConfigurations) {
      this.documentService.GetDocumentConfigurationById(documentConfigurations).subscribe(result => {
        this.isDocumentConfigurationLoaded = result;
        this.setFormIsReady();
      }, error => {
        this.showGenericErrorPopup();
      });
    }
  }
  protected getDocumentConfigurations(): DocumentEntity[] {
    let documentConfigurations: DocumentEntity[] = [];
    return documentConfigurations;
  }
  protected loadApplication(applicationId?: string, taskId?: string): void {
    this.applicationService.loadApplication(applicationId, taskId).subscribe(result => {
      if (result.IsSucceeded) {     
        this.handleRetrievedApplication(<TApplication>result.Data);
        this.isApplicationLoaded = true;
        this.setFormIsReady();
      }
      else {
        if (result.MessageCode == ResponseMessageCode.Error) {
          this.showGenericErrorPopup();
          //alert("Error in loading application: " + result.MessageCode);
        }
        else if (result.MessageCode == ResponseMessageCode.PreApplyForServiceValidation) {
          let message = result.Messages && result.Messages.length > 0 ? this.resources[result.Messages[0]] : this.genericErrorMessage;
          this.showGenericErrorPopup(null, message, null);
        }
        else if (result.MessageCode == ResponseMessageCode.Unauthorized) {
          this.showGenericErrorPopup(this.genericErrorTitle, this.resources.g_UnauthorizedMessage, this.genericErrorBackToWorkSpace);
        }
      }
    }, error => {
      this.showGenericErrorPopup();
    });
  }

  protected handleRetrievedApplication(application: TApplication): void {
    this.Application = application;
    this.Application.Request.IsMobile = this.isMobile;
    this.Application.Request.IsResponsive = this.isResponsive;
    this.Application.Request.MobileOS = this.mobileOS;
    if (application.Request && application.Request.IsDraft) {
      this.isDraft = application.Request.IsDraft;
    }
    if (this.Application.Attachments == null)
      this.Application.Attachments = new Array<DocumentModel>();
    this.handleStepsConfigration();
    this.extendHandleRetrievedApplication(application);
  }

  protected handleStepsConfigration() {

    if (this.Application.StepsBarConfiguration && this.Application.StepsBarConfiguration.length > 0) {
      let stepConf: StepsBarConfiguration = null;
      if (this.Application.StepsBarConfiguration.length > 1) {
        stepConf = this.Application.StepsBarConfiguration.filter(x => x.ConfigurationId == 1)[0];
      }
      else {
        stepConf = this.Application.StepsBarConfiguration[0];
      }
      this.steps = JSON.parse(stepConf.Json);
      if (this.Application.CurrentRequestStatus) {
        this.activeStep = this.Application.CurrentRequestStatus.toString();
      }
      else {
        this.activeStep = "0";
      }
      let isStepActive: boolean = false;
      this.steps[0].isComplited = false;
      this.steps[0].isCurrent = true;
      for (var i = 1; i < this.steps.length; i++) {
        let _status = this.steps[i].Status.split(',');
        if (_status.find(x => x == this.activeStep)) {
          this.steps[i].isCurrent = true;
          this.steps[0].isComplited = true;
          isStepActive = true;
          break;
        }
      }
      if (isStepActive) {
        this.steps[0].isComplited = true;
        this.steps[0].isCurrent = false;
        for (var i = 1; i < this.steps.length; i++) {
          if (this.steps[i].isCurrent) {
            if (i == (this.steps.length - 1)) {
              this.steps[i].isComplited = true;
              this.steps[i].isCurrent = false;
            }
            break;
          }
          else {
            this.steps[i].isComplited = true;
            this.steps[i].isCurrent = false;
          }
        }
      }
      for (var i = 0; i < this.steps.length; i++) {
        this.steps[i].Percentage = Math.trunc((i / (this.steps.length - 1)) * 100);
      }
    }

  }

  protected setStepsConfigration(configrationId: number, statusID: string = "") {

    if (this.Application.StepsBarConfiguration && this.Application.StepsBarConfiguration.length >0) {
      let stepConf: StepsBarConfiguration = null;
      if (this.Application.StepsBarConfiguration.length > 1) {
        stepConf = this.Application.StepsBarConfiguration.filter(x => x.ConfigurationId == configrationId)[0];
      }
      else {
        stepConf = this.Application.StepsBarConfiguration[0];
      }
      this.steps = JSON.parse(stepConf.Json);
      if (this.Application.CurrentRequestStatus) {
        this.activeStep = this.Application.CurrentRequestStatus.toString();
      }
      else {
       
          this.activeStep = "0";
      }
      if (statusID.length > 0)
        this.activeStep = statusID;
      
      let isStepActive: boolean = false;
      this.steps[0].isComplited = false;
      this.steps[0].isCurrent = true;
      for (var i = 1; i < this.steps.length; i++) {
        let _status = this.steps[i].Status.split(',');
        if (_status.find(x => x == this.activeStep)) {
          this.steps[i].isCurrent = true;
          this.steps[i].isComplited = false;
          isStepActive = true;
          break;
        }
      }
      if (isStepActive) {
        this.steps[0].isComplited = true;
        this.steps[0].isCurrent = false;
        for (var i = 1; i < this.steps.length; i++) {
          if (this.steps[i].isCurrent) {
            if (i == (this.steps.length - 1)) {
              this.steps[i].isComplited = true;
              this.steps[i].isCurrent = false;
            }
            break;
          }
          else {
            this.steps[i].isComplited = true;
            this.steps[i].isCurrent = false;
          }
        }
      }

      for (var i = 0; i < this.steps.length; i++) {
        this.steps[i].Percentage = Math.trunc((i / (this.steps.length - 1)) * 100);
      }
    }

  }


  protected extendHandleRetrievedApplication(application: TApplication): void { }

  protected setFormIsReady(): void {
    if (this.isResourcesLoaded && this.isLookupsLoaded && this.isApplicationLoaded && this.isDocumentConfigurationLoaded && this.isExtendedLoaded) {
      this.handleDeletedLookups();
      this.isFormReady = true;
      this.isFormReadyEventEmitter.emit();
      this.afterFormReady();
      this.commonService.hideLoader();
     
    }
  }
  

  protected afterFormReady(): void {

  }
  public saveForm(): void {

    this.Application.IsSubmitted = false;
    this.isSubmitApplication = false;
    this.isSaveApplication = true;
    let self = this;
    //let isValid = this.validateApplicationBeforeSave();
    setTimeout(function () {
      if (self.validateTabs()) {
        self.TrimWhiteSpaces(self.Application);
        self.preSaveApplication();
        self.saveApplication(self.Application);
      }
    });
  }

  protected preSaveApplication(): void {

  }

  protected validateApplicationBeforeSave(): boolean {
    return true;
  }

  protected saveApplication(application: TApplication): void {
    this.commonService.showLoader();
    this.applicationService.saveApplication(application).subscribe(result => {
      //this.commonService.hideLoader();
      if (result.IsSucceeded) {
        this.onSaveApplicationSuccess(<TApplication>result.Data);
        if (result.SuccessActionCode == SuccessActionCode.RedirectToSuccessPage)
          this.redirectToSuccessPage();
        else if (result.SuccessActionCode == SuccessActionCode.RedirectToPayment) {
          this.redirectToPaymentPage();
        }
        else if (result.SuccessActionCode == SuccessActionCode.RedirectToAppointment) {
          this.redirectToAppointmentPage();
        }
        else if (result.SuccessActionCode == SuccessActionCode.RedirectToAttachments) {
          this.redirectToAttachmentsPage();
        }
      }
      else {
        this.onSaveApplicationError(result);
        if (result.MessageCode == ResponseMessageCode.Error) {
          if (result.Messages.length>0 && result.Messages.filter(x => x == "PassportHasAnOpenRequest").length > 0) {
           // let message = result.Messages && result.Messages.length > 0 ? this.resources.: this.genericErrorMessage;
            this.showGenericErrorPopup(this.genericErrorTitle, this.resources.passportHasAnOpenRequest, this.genericErrorBackToWorkSpace);
           // this.showGenericErrorPopup(null, message, null);
          }
          else if (result.Messages.length > 0 && result.Messages.filter(x => x == "ScholarshipEndDate").length > 0) {
           // let message = result.Messages && result.Messages.length > 0 ? this.resources.: this.genericErrorMessage;
            this.showGenericErrorPopup(this.genericErrorTitle, this.resources.ScholarshipServiceNotAvailableAtThisTime, this.genericErrorBackToWorkSpace);
           // this.showGenericErrorPopup(null, message, null);
          }
          else if (result.Messages.length > 0 && result.Messages.filter(x => x == "ScholarshipIDAlreadyExsist").length > 0) {
            // let message = result.Messages && result.Messages.length > 0 ? this.resources.: this.genericErrorMessage;
            this.showGenericErrorPopup(this.genericErrorTitle, this.resources.ScholarshipIDAlreadyExsist, this.genericErrorBackToWorkSpace);
            // this.showGenericErrorPopup(null, message, null);
          }
          else if (result.Messages.length > 0 && result.Messages.filter(x => x == "ParentIDNumberInvalid").length > 0) {
            // let message = result.Messages && result.Messages.length > 0 ? this.resources.: this.genericErrorMessage;
            this.showGenericErrorPopup(this.genericErrorTitle, this.resources.GuardiansIDNotExist, this.genericErrorBackToWorkSpace);
            // this.showGenericErrorPopup(null, message, null);
          }
          else if (result.Messages.length > 0 && result.Messages.filter(x => x == "DuplicateContactFound").length > 0) {
            // let message = result.Messages && result.Messages.length > 0 ? this.resources.: this.genericErrorMessage;
            this.showGenericErrorPopup(this.genericErrorTitle, this.resources.DuplicateContactFound, this.genericErrorBackToWorkSpace);
            // this.showGenericErrorPopup(null, message, null);
          }
          else if (result.Messages.length > 0 && result.Messages.filter(x => x == "InvalidVerificationCode").length > 0) {
            // let message = result.Messages && result.Messages.length > 0 ? this.resources.: this.genericErrorMessage;
            this.showGenericErrorPopup(this.genericErrorTitle, this.resources.g_InvalidVerificationCode, this.genericErrorBackToWorkSpace);
            // this.showGenericErrorPopup(null, message, null);
          }
          else if (result.Messages.length > 0 && result.Messages.filter(x => x == "gCaptchaV3VerificationFailed").length > 0) {
            this.showGenericErrorPopup(this.genericErrorTitle, this.resources.g_gCaptchaV3VerificationFailed, this.genericErrorBackToWorkSpace);
          }
          else {


            this.showGenericErrorPopup(null, "Sorry, something went wrong please try again later.", null);
          }
        }
        else if (result.MessageCode == ResponseMessageCode.PreApplyForServiceValidation) {
          let message = result.Messages && result.Messages.length > 0 ? this.resources[result.Messages[0]] : this.genericErrorMessage;
          this.showGenericErrorPopup(null, message, null);
        }
        else if (result.MessageCode == ResponseMessageCode.UnvalidSavingRequest) {
          let message = result.Messages && result.Messages.length > 0 ? this.resources[result.Messages[0]] : this.genericErrorMessage;
          this.showGenericErrorPopup(null, message, null);
        }
      }
    }, error => {
      if (error.status == 401)
        this.showGenericErrorPopup(this.genericErrorTitle, this.resources.g_SessionTimeOut, this.genericErrorBackToWorkSpace);
      else
        this.showGenericErrorPopup();
    });
  }
  protected CloseRequest(): void {
    this.Application.Action = ActionCode.Close;
    this.submitForm();
  }
  protected redirectToSuccessPage(): void {
    if (this.taskId) {
      this.commonService.redirectToSuccessPage(this.Application.ApplicationId,
        this.applicationId ? SuccessConfirmationCode.UpdateApplication : SuccessConfirmationCode.SubmitTask,
        this.Application.ReferenceNumber, this.Application.TaskId);
    }
    else {
      if (this.isSubmitApplication) {
        this.commonService.redirectToSuccessPage(this.Application.ApplicationId,
          (this.applicationId && !this.isDraft) ? SuccessConfirmationCode.UpdateApplication : SuccessConfirmationCode.SubmitApplication,
          this.Application.ReferenceNumber, this.Application.TaskId);
      }
      else {
        this.commonService.redirectToSuccessPage(this.Application.ApplicationId,
          this.applicationId ? SuccessConfirmationCode.UpdateApplication : SuccessConfirmationCode.SaveApplication,
          this.Application.ReferenceNumber, this.Application.TaskId);
      }
    }
  }
  protected redirectToPaymentPage(): void {
    this.commonService.redirectToPaymentPage(this.Application.ApplicationId, this.Application.TaskId);
  }
  protected redirectToAppointmentPage(): void {
    this.commonService.redirectToAppointmentPage(this.Application.ApplicationId, this.Application.TaskId);
  }
  protected redirectToAttachmentsPage(): void {
    this.commonService.redirectToAttachmentsPage(this.Application.Request.Service.ViewUrl,this.Application.ApplicationId, this.Application.TaskId);
  }

  protected onSaveApplicationSuccess(application: TApplication): void {
    this.Application = application;
    this.extendOnSaveApplicationSuccess();
  }

  protected extendOnSaveApplicationSuccess(): void { }

  protected onSaveApplicationError(result: ResultDetails): void {

  }

  public submitForm(): void {
    
    this.Application.IsSubmitted = true;
    this.isSubmitApplication = true;
    this.isSaveApplication = true;
    let self = this;
    setTimeout(function () {
      if (self.validateTabs()) {
        self.TrimWhiteSpaces(self.Application);
        self.preSaveApplication();
        self.preSubmitApplication();
        self.saveApplication(self.Application);
      }
    });
  }

  protected preSubmitApplication(): void { }

  protected validateTabs(): boolean {
    let valid = true;
    let tabs = this.tabs();
    for (var i = 0; i < tabs.length; i++) {
      if ((!tabs[i].isHidden || (tabs[i].isHidden && !tabs[i].isHidden(this)))
        && !this.validateForm(tabs[i].form) || (tabs[i].isTabValid != null && !tabs[i].isTabValid(this))) {
        valid = false;
        this.setTabFocus(tabs[i].tabIndex);
        let self = this;
        setTimeout(function () {
          self.scrollUpToTabs();
          self.scrollUpToFirstError();
          self.scrollUpToCustomError();
          //self.scrollUpToFirstError();
        }); 
        //this.scrollUpToTabs();
        //this.scrollUpToFirstError();
        break;
      }
    }
    return valid;
  }

  protected validateForm(form: NgForm | FormGroup): boolean {
    if (form.valid) {
      return true;
    }
    else {
      let valid = true;
      let controls = form.controls
      Object.keys(controls).forEach(key => {
        if (controls[key].status != 'DISABLED')
          valid = false;
      });
      return valid;
    }
  }

  protected scrollUpToTabs(): void {
    //let target = document.querySelector('.ng-invalid');
    //var rect = target.getBoundingClientRect();
    //var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //var targetTop = rect.top + scrollTop;

    //if (target)
    //  window.scrollTo(targetTop);
    //target.scrollIntoView({ behavior: 'smooth' });
    //target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

    let target;
    let fieldContainers = document.querySelectorAll('.ng-invalid .field-container');

    for (var i = 0; i < fieldContainers.length; i++) {
      if (fieldContainers[i].querySelector('.field-validation-error')) {
        target = fieldContainers[i];
        break;
      }
    }

    //let target = document.querySelector('.ng-invalid .field-validation-error').parentElement.querySelectorAll('.field-container')[0];
    if (target && getComputedStyle(target, null).visibility != "hidden" && getComputedStyle(target, null).display != "none")
      window.scrollTo({
        top: target.getBoundingClientRect().top + (window.scrollY - 110),
        behavior: 'smooth'
      });
    //target.scrollIntoView({ behavior: 'smooth' });
    //target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  }

  protected scrollUpToFirstError(): void {
    let target;
    let fieldContainers = document.querySelectorAll('.field-container');

    for (var i = 0; i < fieldContainers.length; i++) {
      if (fieldContainers[i].querySelector('.field-validation-error')) {
        target = fieldContainers[i];
        break;
      }
    }

    if (target && getComputedStyle(target, null).visibility != "hidden" && getComputedStyle(target, null).display != "none")
      window.scrollTo({
        top: target.getBoundingClientRect().top + (window.scrollY - 110),
        behavior: 'smooth'
      });
  }
  protected scrollUpToCustomError(): void {
    let target = document.querySelectorAll('.error-msg')[0];
    if (target && getComputedStyle(target, null).visibility != "hidden" && getComputedStyle(target, null).display != "none")
      window.scrollTo({
        top: target.getBoundingClientRect().top + (window.scrollY - 110),
        behavior: 'smooth'
      });
  }
  protected setTabFocus(index: number) {
    this.activeTab = index;
  }

  protected showGenericErrorPopup(title?: string, message?: string, actionLabel?: string): void {
    this.hasError = true;
    this.commonService.hideLoader();
    if (title)
      this.genericErrorTitle = title;
    if (message)
      this.genericErrorMessage = message;
    if (actionLabel)
      this.genericErrorBackToWorkSpace = actionLabel;
    this.modalService.open(this.getGenericErrorPopup());
  }

  public backToWorkSpace(): void {
    this.isBack = true;
    this.commonService.backToWorkSpace();
  }
  protected back(): void {
    this.isBack = true;
    this.commonService.back(this.applicationId, this.resourceService.getCurrentLanguage());
  }
  protected getGenericErrorPopup(): string {
    return "genericErrorPopup";
  }

  protected setRequestAction(actionCode: ActionCode): void {
    this.Application.Action = actionCode;
  }
  @HostListener('window:beforeunload', ['$event'])
  public onbeforeunload($event) {
    if (this.isSaveApplication || this.isBack || this.hasError || (this.Application != null && !this.Application.IsEditable)) {
      //$event.preventDefault();
      return true;
    }
    $event.returnValue = "Are you sure?";
  }
  protected TrimWhiteSpaces(application: any) {
    Object.keys(application).forEach(key => {
      if (typeof application[key] == "string")
        application[key] = application[key].trim();
    });
  }

  protected showHappinessMeterAfterRedirectToSuccessPage(): boolean {
    if (this.isSubmitApplication && (this.taskId == null || this.taskId == ''))
      return true;
    return false;
  }
  protected formatDiplomaticCardNumber(cardNumber): string {
    try {
      const card = cardNumber.split('/');
      if (card.length === 4) {
        return `${parseInt(card[0])}/${parseInt(card[1])}/${parseInt(card[2])}/${parseInt(card[3])}`;
      }
    } catch (ex) {
      return "";
    }
  }

  protected formatMaskDiplomaticCardNumber(cardNumber): string {
    try {
      const card = cardNumber.split('/');
      if (card.length === 4) {
        return `${this.padZeroBase(parseInt(card[0]), 2, '0')}/${this.padZeroBase(parseInt(card[1]), 4, '0')}/${this.padZeroBase(parseInt(card[2]), 2, '0')}/${parseInt(card[3])}`;
      }
    } catch (ex) {
      return "";
    }
  }
  protected formatPadDiplomaticCardNumber(cardNumber): string {
    try {
      const card = cardNumber.split('/');
      if (card.length === 4) {
        return `${this.padZeroBase(parseInt(card[0]), 2, '0')}/${this.padZeroBase(parseInt(card[1]), 4, '0')}/${this.padZeroBase(parseInt(card[2]), 2, '0')}/${parseInt(card[3])}`;
      }
    } catch (ex) {
      return "";
    }
  }
  protected formatCRMDiplomaticCardNumber(cardNumber): string {
    try {
      const card = cardNumber.split('/');
      if (card.length === 4) {
        return `${parseInt(card[0])}/${parseInt(card[1])}/${parseInt(card[2])}/${parseInt(card[3])}`;
      }
    } catch (ex) {
      return "";
    }
  }
  protected padZeroBase(value: number | string, totalLength: number, padChar: string): string {
    return value.toString().padStart(totalLength, padChar);
  }

  protected StrRemoveAllSpaces(str: string): string {
    return str.replace(/\s+/g, '');
  }
  validateNullorEmptyGuid = function validateNullorEmpty(ValueStr: string) {
    try {
      if (ValueStr == null || ValueStr == undefined || ValueStr == "" || ValueStr == "00000000-0000-0000-0000-000000000000" || /^\s + $ /.test(ValueStr)) return true;
      return false
    } catch (e) {

    }
  }
  getFormatedDate(date: Date, format: string) {
    const datePipe = new DatePipe('en-US');
    return datePipe.transform(date, format);
  }
  PrependPlusWithPhoneNumber = function PrependPlusWithPhoneNumber(ContactNumber: string | null | undefined): string | null {
    if (!this.validateNullorEmptyGuid(ContactNumber)) {
      const PhoneNumber = ContactNumber.trim();
      const landlineAreas = ['02', '03', '04', '06', '07', '09'];
      // Skip in case already it start with 00 or +
      if (/^(00|\+)/.test(PhoneNumber)) {
        return PhoneNumber;
      }
      //Skip for lanline number
      const firstTwo = PhoneNumber.slice(0, 2);
      if (landlineAreas.includes(firstTwo)) {
        return PhoneNumber;
      }
      return `+${PhoneNumber}`;
    }
    return ContactNumber ? ContactNumber : null;
  }

  validateNullorEmptyGuidListItemMatch = function validateNullorEmptyGuidListItemMatch(ValueStr: string, listData: LookupKeyValue[], filedKey: string = "") {
    try {
      if (ValueStr == null || ValueStr == undefined || ValueStr == "" || ValueStr == "00000000-0000-0000-0000-000000000000") {
        return true;
      }
      const result = listData.find(item => item.Key == ValueStr);
      if (!result) {
        this.Application[filedKey] = null;
        return true;
      }
      return false;

    } catch (e) {

    }
  }
}

export class CustomTab {
  tabIndex: number;
  form: NgForm | FormGroup;
  formName: string;
  isTabValid?: (self: any) => boolean;
  isHidden?: (self: any) => boolean;
}

